import { render } from "./RDFTabs.vue?vue&type=template&id=2ba85a56&scoped=true"
import script from "./RDFTabs.vue?vue&type=script&lang=js"
export * from "./RDFTabs.vue?vue&type=script&lang=js"

import "./RDFTabs.vue?vue&type=style&index=0&id=2ba85a56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba85a56"]])

export default __exports__